import React from 'react'

import Card from 'react-bootstrap/Card'

import { EventCardBody } from './EventCardBody'
import { VenueCardBody } from './VenueCardBody'
import { TeamCardBody } from './TeamCardBody'

import placeholder from '../../../assets/placeholder.png'

import './myCard.scss'

function getCardImage({ prefix, venue, event, organization }) {
  if (prefix === 'event') return event?.image?.url || placeholder
  if (prefix === 'team') return organization?.image?.url || placeholder
  return venue?.image?.[0]?.url || placeholder
}

function getCardAlt({ prefix, venue, event, organization }) {
  if (prefix === 'event') return `Cover art for ${event?.name} event`
  if (prefix === 'team') return `${organization?.name} team`
  return `${venue?.name} venue`
}

export default function MyCard({ prefix, venue, event, organization }) {
  return (
    <Card className={`myCard myCard--${prefix}`}>
      <Card.Img
        variant="top"
        src={getCardImage({ prefix, venue, event, organization })}
        width="100"
        height="180"
        alt={getCardAlt({ prefix, venue, event, organization })}
        className={prefix === 'team' ? 'team-image' : 'event-image'}
      />
      <Card.Body>
        {prefix === 'event' ? (
          <EventCardBody event={event} />
        ) : prefix === 'team' ? (
          <TeamCardBody organization={organization} />
        ) : (
          <VenueCardBody venue={venue} />
        )}
      </Card.Body>
    </Card>
  )
}
